import React from 'react';
import { ArrowRight } from 'lucide-react';
type EmergencyQuoteFormProps = {
  onSubmit: (e: React.FormEvent) => void;
};
export function EmergencyQuoteForm({
  onSubmit
}: EmergencyQuoteFormProps) {
  return <form className="space-y-4" onSubmit={onSubmit} data-id="element-58">
      <div data-id="element-59">
        <label htmlFor="fullName" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-60">
          Full Name
        </label>
        <input type="text" id="fullName" autoComplete="name" placeholder="John Smith" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-emergencyBrand-red/40 focus:border-emergencyBrand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-61" />
      </div>
      <div data-id="element-62">
        <label htmlFor="phone" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-63">
          Phone Number
        </label>
        <input type="tel" id="phone" autoComplete="tel" placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-emergencyBrand-red/40 focus:border-emergencyBrand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-64" />
      </div>
      <div data-id="element-65">
        <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-1.5" data-id="element-66">
          Email Address
        </label>
        <input type="email" id="email" autoComplete="email" placeholder="john@email.com" className="w-full px-4 py-3 rounded-md border border-slate-300 focus:ring-2 focus:ring-emergencyBrand-red/40 focus:border-emergencyBrand-red outline-none transition-all text-slate-900 placeholder:text-slate-400" required data-id="element-67" />
      </div>
      <button type="submit" className="w-full bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white font-bold uppercase tracking-wide text-sm py-4 rounded-md mt-2 transition-colors shadow-sm flex justify-center items-center gap-2" data-id="element-68">
        Request My Urgent Quote
        <ArrowRight className="w-4 h-4" data-id="element-69" />
      </button>
    </form>;
}